import React, { Component } from 'react';
import Style from './TextSection.css';

class TextSection extends Component{
	render(){
		const item = this.props.textData;
		return (
			<div style={Style.TextSection} className={`text-area ` + this.props.alignItem}>
				<h2>{item.title}</h2>
				<div className="text-body">{item.text}</div>
			</div>
		)
	}  
}

export default TextSection;